import { FC, memo, useMemo, useState } from 'react';

import { useOpenClose } from '~/core/hooks/useOpenClose';
import { PageSize } from '~/core/shared/types';
import { LayoutWrapContextType } from './types/LayoutWrapContext';
import { LayoutWrapProviderProps } from './types/LayoutWrapProps';
import { LayoutWrapContext } from './LayoutWrapContext';

const resolvePageWidth = (size: PageSize): string => {
  // TODO: these sizes should be in a theme file
  switch (size) {
    case 'sm':
      return '500px';
    case 'lg':
      return '1000px';
    case 'xl':
      return '100vw';
    case 'md':
    default:
      return '714px';
  }
};

const LayoutWrapProviderComponent: FC<LayoutWrapProviderProps> = ({
  children,
  value: partialValue,
}) => {
  const [pageWidth, setWidth] = useState(resolvePageWidth('md'));
  const exitConfirmModalApi = useOpenClose();

  const value = useMemo(
    (): LayoutWrapContextType => ({
      exitConfirmModalApi,
      setPageWidth: (w) => setWidth(resolvePageWidth(w)),
      pageWidth,
      isLocked: false,
      ...partialValue,
    }),
    [partialValue, pageWidth, setWidth, exitConfirmModalApi],
  );

  return (
    <LayoutWrapContext.Provider value={value}>
      {children}
    </LayoutWrapContext.Provider>
  );
};

export const LayoutWrapProvider = memo(LayoutWrapProviderComponent);
